var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"py-3 mt-3",attrs:{"flat":_vm.isFlat}},[_c('form-group',{attrs:{"title":"Motivos da mesa"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('analysis-table-reasons-list')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }